import React from "react"
import classnames from "classnames"
import { Container, Section } from "AtomicComponents"
import { HeroContent } from "AtomicContainers"
import componentParser from "AtomicUtils/componentParser"
import styles from "./ContentCardList.less"

class ContentCardList extends React.Component {
  render() {
    const {
      components = [], heading, description, imageSrc
    } = this.props
    return (
      <div>
        <Section backgroundColor="#F5F5F5">
          <HeroContent
            heading={heading}
            description={description}
            imageSrc={imageSrc}
            details={`Showing ${components.length} items`} />
        </Section>
        <Section>
          <Container styleName='screen'>
            <div className={classnames({
              [styles.ContentCardListRoot]: true
            })}>
              <div />
              <div className={classnames({
                [styles.ContentCardListView]: true
              })}>
                {componentParser(components).map((item, index) => (
                  <div
                    key={`ContentCard-${index}`}
                    className={classnames({
                      [styles.ContentCardListViewItem]: true,
                      [styles.ContentCardListViewItemborderBottom]: (index < components.length - 1)
                    })}>
                    {item}
                  </div>
                ))}
              </div>
            </div>
          </Container>
        </Section>
      </div>
    )
  }
}

export default ContentCardList



// WEBPACK FOOTER //
// ./src/AtomicContainers/ContentCardList/ContentCardList.jsx